// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    box-sizing: border-box;
}

.search-form__form.form {
    width: inherit;
} 


/* Style the search field */
.search-form__form  input[type=text] {
    padding: 10px;
    padding-left: 40px;
    float: right;
    max-height: 40px;
    border-radius: 5px;
}
.search-form__form  input[type=text]:focus-within{
    /* border: 3px solid var(--primary-very-dark-color); */
}



.search-form__form svg { 
    position: absolute; 
} 

.search-form__form .MuiSvgIcon-root { 
    fill: #949F9A;
    margin: 10px;
    /*font-size: var(--space) !important;*/
    font-size: 20px;
} 




/* Style the submit button */
.search-form__form button {
    float: left;
    width: 20%;
    /*padding: 10px;*/
    background: var(--white-color);
    color: var(--primary-very-dark-color);
    /*font-size: 17px;
    border: 1px solid grey;*/
    border: none;
    /*border: 3px solid var(--basic-gray-color);
    border-left: none; /* Prevent double borders */
    box-shadow: none;
    cursor: pointer;
}

.search-form__form button:hover {
    background: var(--white-color);
    box-shadow: none;
}

label[for="searchfield"]
{
    display:none;
}

/* Clear floats */
.search-form__form::after {
    content: "";
    clear: both;
    display: table;
}

.search-form__form__input{
    margin: 0;
}


.clearfix::after {
    content: "";
    clear: both;
    display: table;
}

.search-form__mobile-button {
    padding: 0;
    margin-left: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/search/components/search-input/SearchInputComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;;AAGA,2BAA2B;AAC3B;IACI,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,sDAAsD;AAC1D;;;;AAIA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,sCAAsC;IACtC,eAAe;AACnB;;;;;AAKA,4BAA4B;AAC5B;IACI,WAAW;IACX,UAAU;IACV,iBAAiB;IACjB,8BAA8B;IAC9B,qCAAqC;IACrC;4BACwB;IACxB,YAAY;IACZ;kDAC8C;IAC9C,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;;IAEI,YAAY;AAChB;;AAEA,iBAAiB;AACjB;IACI,WAAW;IACX,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,SAAS;AACb;;;AAGA;IACI,WAAW;IACX,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,iBAAiB;AACrB","sourcesContent":["* {\n    box-sizing: border-box;\n}\n\n.search-form__form.form {\n    width: inherit;\n} \n\n\n/* Style the search field */\n.search-form__form  input[type=text] {\n    padding: 10px;\n    padding-left: 40px;\n    float: right;\n    max-height: 40px;\n    border-radius: 5px;\n}\n.search-form__form  input[type=text]:focus-within{\n    /* border: 3px solid var(--primary-very-dark-color); */\n}\n\n\n\n.search-form__form svg { \n    position: absolute; \n} \n\n.search-form__form .MuiSvgIcon-root { \n    fill: #949F9A;\n    margin: 10px;\n    /*font-size: var(--space) !important;*/\n    font-size: 20px;\n} \n\n\n\n\n/* Style the submit button */\n.search-form__form button {\n    float: left;\n    width: 20%;\n    /*padding: 10px;*/\n    background: var(--white-color);\n    color: var(--primary-very-dark-color);\n    /*font-size: 17px;\n    border: 1px solid grey;*/\n    border: none;\n    /*border: 3px solid var(--basic-gray-color);\n    border-left: none; /* Prevent double borders */\n    box-shadow: none;\n    cursor: pointer;\n}\n\n.search-form__form button:hover {\n    background: var(--white-color);\n    box-shadow: none;\n}\n\nlabel[for=\"searchfield\"]\n{\n    display:none;\n}\n\n/* Clear floats */\n.search-form__form::after {\n    content: \"\";\n    clear: both;\n    display: table;\n}\n\n.search-form__form__input{\n    margin: 0;\n}\n\n\n.clearfix::after {\n    content: \"\";\n    clear: both;\n    display: table;\n}\n\n.search-form__mobile-button {\n    padding: 0;\n    margin-left: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
